import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth } from "react-oidc-context";

const API_URL = process.env.REACT_APP_API_URL || "/api";

export const ROOMS_LIMIT_OPTIONS = [
  { value: 10, label: "10" },
  { value: 30, label: "30" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 10000, label: "Max" },
];

export const ROOMS_DEFAULT_LIMIT = 30;

/**
 * @param {boolean} options.enabled  Quand false, aucune requête n'est émise : la page hôtel
 *   ne charge les chambres "Général" que si cet onglet est actif.
 */
export function useUnifiedHotelRooms(masterId, { limit = ROOMS_DEFAULT_LIMIT, page = 1, enabled = true } = {}) {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [data, setData] = useState({
    rooms: [],
    total_count: 0,
    page: 1,
    limit: ROOMS_DEFAULT_LIMIT,
    total_pages: 0,
    app_id: null,
    manager_id: null,
    has_lunishower: false,
    has_greenmiles: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRooms = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    if (!masterId) {
      setLoading(false);
      return;
    }
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const params = new URLSearchParams();
      params.set("limit", String(limit));
      params.set("page", String(page));
      const res = await axios.get(`${API_URL}/home/hotel/${masterId}/rooms?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.success === "OK" && res.data?.result) {
        const result = res.data.result;
        setData({
          rooms: Array.isArray(result.rooms) ? result.rooms : [],
          total_count: Number(result.total_count) ?? 0,
          page: Number(result.page) ?? 1,
          limit: Number(result.limit) ?? limit,
          total_pages: Number(result.total_pages) ?? 0,
          app_id: result.app_id ?? null,
          manager_id: result.manager_id ?? null,
          has_lunishower: Boolean(result.has_lunishower),
          has_greenmiles: Boolean(result.has_greenmiles),
        });
      } else {
        setError(res.data?.message || "Erreur chargement chambres");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Erreur chargement chambres");
      setData((prev) => ({ ...prev, rooms: [] }));
    } finally {
      setLoading(false);
    }
  }, [masterId, token, limit, page, enabled]);

  useEffect(() => {
    fetchRooms();
  }, [fetchRooms]);

  return { ...data, loading, error, refetch: fetchRooms };
}
